import { useState, useEffect } from 'react'
import { InsuranceDate, ExpiryEffectivityDate } from '@src/common/DatePicker';
import DocumentGallery from './DocumentGallery';
import { fetchLeadData, saveInsurancePolicy, updateLeadDetailsInStore } from '@src/store/slices/insurance';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom';
import DocumentForm from "../detail/inbound-outbound-payment/Documents";
import FullPageLoader from '@common/FullPageLoader';
import { SOFT_APPROVAL_RECEIVED_TYPE, POLICY_GENERATED_TYPE, DOCUMENT_CATEGORY, ROLE_FEATURES, WITH_RULE_ENGINE_ID, WITHOUT_RULE_ENGINE, EFFECTIVITY_EXPIRY_INTERVAL, API_TYPES, STATUS_SUB_STATUS, AGENCY_VAL,INS_INSURANCE_ID_STAGE,COUNTRY_CODE,IS_FLEET_ACCOUNT, STATUS_SUCCESS, ALLOW_MONTH, SUBTRACT_YEAR, LAST_MONTH} from "@src/config/constant";
import LeadRemarksButton from '../common/LeadRemarksButton';
import * as HELPER from "../../../config/helper";
import moment from 'moment';
import DocumentFormId from "../detail/inbound-outbound-payment/DocumentsId";
import { useLanguage } from '@src/context/LanguageContext';
import { COND_SHOW_FIELDS_ACC_INSURERS, SENT_TO_VERIFICATION } from '@src/config/id/constant';
// Define the structure of error fields for validation
type ErrFieldState = {
    insPolicyNumber: string;
    InsPolicyGenerateDate: string;
    expiry_date: string;
    effectivity_date: string;
    received_date: string
    partner_policy_number:string
};


const UsePolicyForm = (props: any) => {

    const [insurancePolicyNumber, setInsurancePolicyNumber] = useState('');
    const [partner_policy_number, setPartnerPolicyNumber] = useState('');
    const [insurancePolicyDate, setInsurancePolicyDate] = useState<any>(null);
    const [refrenceNote, setRefrenceNote] = useState('');
    const [inputFields, setInputFields] = useState<{effectivity_date: any, expiry_date: any, received_date: any}>({effectivity_date: null, expiry_date: null, received_date: null});
    const [isFleetAccount, setIsFleetAccount] = useState(0);
    const [maxExpiryDate, setMaxExpiryDate] = useState(moment().add(SUBTRACT_YEAR.ONE, "year").endOf("year").toDate())

    const {translations} = useLanguage();


    const [errField, setErrField] = useState<ErrFieldState>({
        insPolicyNumber: "",
        InsPolicyGenerateDate: "",
        expiry_date: "",
        effectivity_date: "",
        received_date: "",
        partner_policy_number: ""
    });

    let [loading, setLoading] = useState<boolean>(false);
    const [policyId, setPolicyId] = useState<number>();



    // Redux hooks to dispatch actions and access state
    const dispatch: any = useDispatch()
    const insuranceState = useSelector((state: any) => state.insurance)

    const navigate = useNavigate();
    const queryParams: any = useParams();

    const formType = props.formType;

    const [submitClicked, setSubmitClicked] = useState<boolean>(false);
    const [leadDetails, setLeadDetails] = useState<any>({});

    const [filesCount, setFilesCount] = useState<number>(0);
    // eslint-disable-next-line
    const [minExpiryDate, setMinExpiryDate] = useState(moment().toDate())

    let {partner_id,insurer_id,sent_to_verification } = insuranceState?.leadDetail || {};

    // Function to save the insurance policy template
    const saveInsurancePolicyTemplate = () => {
        setSubmitClicked(false);
        
        if (validForm()) {
            setLoading(true);
            
            const formData: any = {};

            // Append other form data to the FormData
            formData['lead_id'] = queryParams.id;
            formData['policy_number'] = insurancePolicyNumber;
            if(INS_INSURANCE_ID_STAGE){
                formData['partner_policy_number'] = partner_policy_number;
            }
            formData['policy_date_time'] = insurancePolicyDate ? insurancePolicyDate.toISOString() : '';
            if (refrenceNote) {
                formData['notes'] = refrenceNote;
            }
            if (formType === 'soft-approval-received') {
                formData['type'] = SOFT_APPROVAL_RECEIVED_TYPE;
            }
            if (formType === 'insurance-policy-generated') {
                formData['type'] = POLICY_GENERATED_TYPE;
                if(!INS_INSURANCE_ID_STAGE){
                    formData['expiry_date'] = inputFields.expiry_date;
                    formData['effectivity_date'] = inputFields.effectivity_date;
                    formData['is_fleet_account'] = isFleetAccount;
                    formData['received_date'] = inputFields.received_date;
                }
            }


            formData['id'] = policyId ? policyId : '';

            saveInsurancePolicy(formData).then(async (res: any) => {

                if (res.status === STATUS_SUCCESS) {
                    toast.success(res.message);


                    if (res.data && Object.keys(res.data).length) {
                        setSubmitClicked(true);
                        setLeadDetails({ ...insuranceState.leadDetail, ...res.data });

                    } else {
                        setLoading(false);

                    }
                } else {
                    toast.error('Failed to Update');
                    setLoading(false);

                }
            }).catch((error) => {
                setLoading(false);

                toast.error('An error occurred');
            });
        }
    };

    // Function to handle changes in input fields
    const onChangeHandler = (value: any, type: any) => {
        if (type === 'insurancePolicyNumber') {
            if (value && value.trim()) {
                setInsurancePolicyNumber(value);
            }
            else {
                setInsurancePolicyNumber('');
            }     
            setErrField((prev)=>({
                ...prev,
                insPolicyNumber: ""
            }));
        }
        if(type === 'partner_policy_number'){
            if (value && value.trim()) {
                setPartnerPolicyNumber(value);
            }
            else {
                setPartnerPolicyNumber('');
            }     
            setErrField((prev)=>({
                ...prev,
                partner_policy_number: ""
            }));
        }
        if (type === 'refrenceNote') {
            setRefrenceNote(value);
        }
        if (type === 'PolicyDate') {
            setInsurancePolicyDate(value);

            setErrField((prev)=>({
                ...prev,
                InsPolicyGenerateDate: ""
            }));
        }
        if(type === 'is_fleet_account'){
            setIsFleetAccount(value)
        }

        if(['effectivity_date', 'expiry_date', 'received_date'].includes(type)) {
            let errorObj: any = { [type]: "" }
            //reset expiry date error
            if (type === 'effectivity_date' && value && inputFields.expiry_date && !moment(inputFields.expiry_date).isBefore(value)) {
                errorObj = { ...errorObj, expiry_date: "" }
            }

            if(type === 'effectivity_date' && value) {
                if(inputFields.expiry_date && moment(inputFields.expiry_date).startOf('day').diff(moment(value).startOf('day'), 'days') < EFFECTIVITY_EXPIRY_INTERVAL) setInputFields((prev: any) => { return {...prev, expiry_date: null}})
                const minExpiry = moment(value).add(EFFECTIVITY_EXPIRY_INTERVAL, 'days').set({ h: 0, m: 0, s: 0 }).toDate()
                setMinExpiryDate(minExpiry);
                const maxExpiry = moment(minExpiry)
                    .add(SUBTRACT_YEAR.THREE, 'year')
                    .toDate();
                setMaxExpiryDate(maxExpiry);
            }
            setInputFields((prev) => {
                return {...prev, [type]: value}
            })
            setErrField((prev)=>({
                ...prev,
                ...errorObj
            }));
        }

    }

    // Validate the form fields before submitting
    const validForm = () => {
        let formIsValid = true;
        setErrField({
            insPolicyNumber: "",
            InsPolicyGenerateDate: "",
            effectivity_date: "",
            expiry_date: "",
            received_date: "",
            partner_policy_number:""
        });

        if (insurancePolicyNumber === "" && formType === 'insurance-policy-generated') {

            formIsValid = false;
            setErrField((prevState) => ({
                ...prevState,
                insPolicyNumber: "Insurance Policy Number is required",
            }));
        }
        if (partner_policy_number === "" && formType === 'insurance-policy-generated' && partner_id === 1 && INS_INSURANCE_ID_STAGE) {

            formIsValid = false;
            setErrField((prevState) => ({
                ...prevState,
                partner_policy_number: "Qqala Policy Number is required",
            }));
        }
        if (!insurancePolicyDate) {
            formIsValid = false;
            setErrField((prevState) => ({
                ...prevState,
                InsPolicyGenerateDate: "Insurance policy generated date is required",
            }));
        }

        if(formType === 'insurance-policy-generated' && !INS_INSURANCE_ID_STAGE) {
            let fieldsToValidate = ['expiry_date', 'effectivity_date']
            fieldsToValidate.forEach((field: any) => {
                if(!inputFields[field as keyof typeof inputFields]) {
                    let msg = field.replaceAll('_', " ")
                    msg = `Insurance policy ${msg} is Required`
                    setErrField((prevState) => ({
                        ...prevState,
                        [field]: msg
                    }));
                }
            })

            if(inputFields.expiry_date && inputFields.effectivity_date) {
                let checkIfExpiryValid = moment(inputFields.expiry_date).isBefore(inputFields.effectivity_date)
                let checkIfEffDateValid = moment(inputFields.expiry_date).startOf('day').diff(moment(inputFields.effectivity_date).startOf('day'), 'days') < 60 ? true : false
                let errorMessage = checkIfEffDateValid ? `Interval between Expiry date and Effectivity date should be of ${EFFECTIVITY_EXPIRY_INTERVAL} days`: null

                if(checkIfExpiryValid || checkIfEffDateValid) {
                    formIsValid = false
                    setErrField((prevState) => ({
                        ...prevState,
                        expiry_date: errorMessage ? errorMessage : `The Expiry date cannot be earlier than the Effectivity date.`
                    }));
                }
            }
        }


        let getPolicySharedDoc = insuranceState?.leadDetail?.images.filter((docs: any) => docs.doc_type_id === DOCUMENT_CATEGORY['disbursal']['childs']['policy_shared']);

        let getSoftApprovalDoc = insuranceState?.leadDetail?.images.filter((docs: any) => docs.doc_type_id === DOCUMENT_CATEGORY['disbursal']['childs']['soft_approval']);

        //SOFT APPROVAL DOC CHECK IN CASE OF WITHOUT RULE ENGINE
        if (!getSoftApprovalDoc.length && !filesCount && formType === 'soft-approval-received' && +insuranceState.leadDetail.rule_engine_id === WITHOUT_RULE_ENGINE) {
            formIsValid = false;
            setErrField((prevState) => ({
                ...prevState,
                policyDocument: "Please select at least one soft approval document",
            }));
        }

        //POLICY SHARED DOC CHECK
        if (!getPolicySharedDoc.length && !filesCount && formType === 'insurance-policy-generated') {
            formIsValid = false;
            setErrField((prevState) => ({
                ...prevState,
                policyDocument: "Please select at least one policy document",
            }));
        }

        return formIsValid;
    };


    // Redirect to the next page after successful update
    const nextPageRedirect = () => {

        if (formType === 'insurance-policy-generated') {
            navigate(`/details/policy-terms-finalized/${queryParams.id}`);
        }
        if (formType === 'soft-approval-received') {
            navigate(`/details/insurance-policy-generated/${queryParams.id}`);
        }

    }


    //  Fetch insurance details when the component mounts  - type 2 is for Insurance Policy Generated
    useEffect(() => {
        if (insuranceState && insuranceState.leadDetail) {

            if (formType === 'soft-approval-received') {
                setRefrenceNote((insuranceState.leadDetail.soft_approval_notes) || "");
                setPolicyId((insuranceState.leadDetail.soft_approval_id) || "");
                const policyDate = insuranceState.leadDetail.soft_approval_date_time && new Date(insuranceState.leadDetail.soft_approval_date_time);
                setInsurancePolicyDate(policyDate);
            }
            if (formType === 'insurance-policy-generated') {
                setIsFleetAccount(+(insuranceState.leadDetail.is_fleet_account) || 0)
                setRefrenceNote((insuranceState.leadDetail.policy_generate_notes) || "");
                setInsurancePolicyNumber((insuranceState.leadDetail.policy_number) || "");
                setPartnerPolicyNumber((insuranceState.leadDetail.partner_policy_number) || "")
                setPolicyId(insuranceState.leadDetail.policy_generate_id);
                const policyDate = insuranceState.leadDetail.policy_generate_date_time && new Date(insuranceState.leadDetail.policy_generate_date_time);
                setInsurancePolicyDate(policyDate);

                let effDate = insuranceState.leadDetail.policy_effectivity_date ? new Date(insuranceState.leadDetail.policy_effectivity_date) : null
                let expDate = insuranceState.leadDetail.policy_expiry_date ? new Date(insuranceState.leadDetail.policy_expiry_date) : null
                let receivedDate = insuranceState.leadDetail.received_date ? new Date(insuranceState.leadDetail.received_date) : null

                let dates = {effectivity_date : effDate, expiry_date: expDate, received_date: receivedDate}
                
                const minExpiry = moment(effDate).add(EFFECTIVITY_EXPIRY_INTERVAL, 'days').set({ h: 0, m: 0, s: 0 }).toDate()
                setMinExpiryDate(minExpiry);
                const maxExpiry = moment(minExpiry)
                    .add(SUBTRACT_YEAR.THREE, 'year')
                    .toDate();
                setMaxExpiryDate(maxExpiry);

                setInputFields(dates)
                
            }
            setErrField((prev)=>({
                InsPolicyGenerateDate:"",
                insPolicyNumber: "",
                expiry_date: "",
                effectivity_date: "",
                received_date: "",
                partner_policy_number:""
            }));
        }
        // eslint-disable-next-line
    }, [formType, insuranceState]);


    useEffect(() => {
        if (formType && insuranceState.leadDetail.customer_api_call) {
            setLoading(true)
            let reqst: any = { lead_id: queryParams.id }
            let apiType = formType === 'soft-approval-received' ? API_TYPES['softApprovalData'] : API_TYPES['policyGeneratedData']

            fetchLeadData({ ...reqst, apiType }).then((res: any) => {
                if (res && res.data && Object.keys(res.data).length) {
                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }))
                }
            }).finally(() => setLoading(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formType, insuranceState.leadDetail.customer_api_call])


    const resolveFileUpload = (filesStatus: any) => {
        setLoading(false);

        if (filesStatus.status) {
            dispatch(updateLeadDetailsInStore({ ...leadDetails, images: [...leadDetails.images, ...filesStatus.data] }));
            nextPageRedirect();

        }

    }

    const handleSoftApprovalSkip = (e: any) => {
        //SKIP IF NOT ALREADY SAVED
        if (!insuranceState?.leadDetail.soft_approval_id) {
            setLoading(true);
            e.preventDefault();

            let formData: any = {};

            formData['lead_id'] = queryParams.id;
            formData['type'] = SOFT_APPROVAL_RECEIVED_TYPE;
            formData['isSkip'] = true;


            saveInsurancePolicy(formData).then(async (res: any) => {
                if (res.status === STATUS_SUCCESS) {

                    dispatch(updateLeadDetailsInStore({ ...insuranceState.leadDetail, ...res.data }));

                    navigate(`/details/insurance-policy-generated/${queryParams.id}`);

                }
                setLoading(false);

            }).catch(err => setLoading(false));
        }
    }

    const updatedFileCount = (param:any) => {
        setFilesCount(param);
        setErrField((prev)=> ({...prev, policyDocument: ''}))
    }

    const pastSixMonths = new Date(new Date().getFullYear(), new Date().getMonth() - 6, new Date().getDate())

    // Effectivity min / max dates
    const effectivityMinDate = moment().subtract(SUBTRACT_YEAR.SIX, "month").toDate();


    const effectivityMaxDate = moment()
        .add(SUBTRACT_YEAR.ONE, "year")
        .toDate();

    const receivedMinDate = moment().subtract(SUBTRACT_YEAR.THREE, "year").toDate()
   
    return (
        <div className="image-form-outer">
            <FullPageLoader show={loading} />
            <div className="image-tab-panel">
                <DocumentGallery formType={props?.formType} />
            </div>
            <div className="form-tab-right-panel wrapperPosition inspolicyshared">
                <div className="lead-detail-from-outer">
                    <div className="lead-form-heading">
                        <h2>
                            {formType === "soft-approval-received" ? "Soft Approval Received" :
                                formType === "insurance-policy-generated" ? `${translations.Insurance?.['Insurance Policy Generated'] || translations.commonMsg?.loading}` :
                                    ""}
                        </h2>
                        {(((+insuranceState?.leadDetail?.rule_engine_id === WITH_RULE_ENGINE_ID) || (+insuranceState?.leadDetail?.application_type_id === AGENCY_VAL)) && formType === "soft-approval-received") && !insuranceState.leadDetail.soft_approval_id && +insuranceState?.leadDetail?.status_id !== STATUS_SUB_STATUS['status']['lost'] &&
                            <NavLink className="skip-txt" to={`/details/insurance-policy-generated/${queryParams.id}`} onClick={handleSoftApprovalSkip}>Skip</NavLink>
                        }
                    </div>
                    <div className="lead-form-filed">

                        <div className="row">
                            {formType === "insurance-policy-generated"
                                &&
                                <fieldset className="col-md-12">
                                    <div className="material" title = {insurancePolicyNumber}>
                                        <input value={insurancePolicyNumber} onChange={(e: any) => onChangeHandler(e.target.value, 'insurancePolicyNumber')} id="" type="text" placeholder=" " name="RoleName" className="form-input" />
                                        <label data-label={`${translations.Insurance?.['Insurance Policy Number'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                                        {errField.insPolicyNumber && (
                                            <span className="error-txt">
                                                {errField['insPolicyNumber']}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                            }

                            {formType === "insurance-policy-generated" && INS_INSURANCE_ID_STAGE && partner_id === 1  &&
                                <fieldset className="col-md-12">
                                    <div className="material" title = {partner_policy_number}>
                                        <input value={partner_policy_number} onChange={(e: any) => onChangeHandler(e.target.value, 'partner_policy_number')} id="" type="text" placeholder=" " name="partner_policy_number" className="form-input" />
                                        <label data-label={`${translations.Insurance?.['QOALA Policy No'] || translations.commonMsg?.loading}. *`} className="form-label"></label>
                                        {errField.partner_policy_number && (
                                            <span className="error-txt">
                                                {errField['partner_policy_number']}
                                            </span>
                                        )}
                                    </div>
                                </fieldset>
                            }

                            <fieldset className="col-md-12">
                                <div className={(insurancePolicyDate) ? "active-label material animation-effect" : "material animation-effect "}>
                                    <InsuranceDate
                                        onChange={(e: Date) => onChangeHandler(e, 'PolicyDate')}
                                        placeholder=""
                                        text={formType === "insurance-policy-generated" ? `${translations.Insurance?.['Insurance Policy Generated Date'] || translations.commonMsg?.loading} *`: `${translations.Insurance?.['Insurance Acceptance Received Date'] || translations.commonMsg?.loading} *`}
                                        insurancePolicyDate={insurancePolicyDate}
                                        minDate={(["soft-approval-received", "insurance-policy-generated"].includes(formType)) ? moment().subtract(SUBTRACT_YEAR.THREE, "year").toDate(): undefined}
                                    />
                                    {errField.InsPolicyGenerateDate && (
                                        <span className="error-txt">
                                            {errField['InsPolicyGenerateDate']}
                                        </span>
                                    )}
                                </div>

                            </fieldset>

                            {
                                formType === "insurance-policy-generated" && !INS_INSURANCE_ID_STAGE
                                    ?
                                    <>
                                        <fieldset className="col-md-12">
                                            <div className={(inputFields?.effectivity_date) ? "active-label material animation-effect" : "material animation-effect "}>
                                                <ExpiryEffectivityDate
                                                    onChange={(e: Date) => onChangeHandler(e, 'effectivity_date')}
                                                    placeholder=""
                                                    text={"Insurance Policy Effectivity Date *"}
                                                    insurancePolicyDate={inputFields?.effectivity_date || new Date()}
                                                    minDate = {effectivityMinDate}
                                                    maxDate={inputFields.expiry_date && !inputFields.effectivity_date && moment(inputFields.expiry_date).startOf('day').diff(moment().startOf('day').toDate(), 'days') < EFFECTIVITY_EXPIRY_INTERVAL ? new Date(0) : effectivityMaxDate}
                                                    flag = 'effectivity_date'
                                                    dateFormat="dd MMM, yyyy"
                                                    showTimeSelect={false}
                                                />
                                                {errField.effectivity_date && (
                                                    <span className="error-txt">
                                                        {errField['effectivity_date']}
                                                    </span>
                                                )}
                                            </div>

                                        </fieldset>

                                        <fieldset className="col-md-12">
                                            <div className={(inputFields?.expiry_date) ? "active-label material animation-effect" : "material animation-effect "}>
                                                <ExpiryEffectivityDate
                                                    onChange={(e: Date) => onChangeHandler(e, 'expiry_date')}
                                                    placeholder=""
                                                    text={"Insurance Policy Expiry Date *"}
                                                    insurancePolicyDate={inputFields?.expiry_date}
                                                    minDate={inputFields?.effectivity_date ? new Date(new Date(inputFields.effectivity_date).setDate(new Date(inputFields.effectivity_date).getDate() + EFFECTIVITY_EXPIRY_INTERVAL)) : new Date()}
                                                    maxDate={maxExpiryDate}
                                                    flag = 'expiry_date'
                                                    effectivity_date = {inputFields?.effectivity_date || new Date()}
                                                    dateFormat="dd MMM, yyyy"
                                                    openToDate={inputFields?.effectivity_date ? new Date(new Date(inputFields.effectivity_date).setDate(new Date(inputFields.effectivity_date).getDate() + EFFECTIVITY_EXPIRY_INTERVAL)) : new Date()}
                                                    showTimeSelect={false}
                                                />
                                                {errField.expiry_date && (
                                                    <span className="error-txt">
                                                        {errField['expiry_date']}
                                                    </span>
                                                )}
                                            </div>

                                        </fieldset>

                                        <fieldset className="col-md-12">
                                            <div className={(inputFields?.received_date) ? "active-label material animation-effect" : "material animation-effect "}>
                                                <ExpiryEffectivityDate
                                                    onChange={(e: Date) => onChangeHandler(e, 'received_date')}
                                                    placeholder=""
                                                    text={"Case Received Date *"}
                                                    insurancePolicyDate={inputFields?.received_date}
                                                    flag = 'received_date'
                                                    dateFormat="dd MMM, yyyy"
                                                    showTimeSelect={false}
                                                    maxDate={new Date()}
                                                    minDate={receivedMinDate}
                                                />
                                                {errField.received_date && (
                                                    <span className="error-txt">
                                                        {errField['received_date']}
                                                    </span>
                                                )}
                                            </div>

                                        </fieldset>

                                    </>
                                    : ""
                            }
                            <fieldset className="col-md-12">
                                <div className="material" title = {refrenceNote}>
                                    <input value={refrenceNote} id="" onChange={(e: any) => onChangeHandler(e.target.value, 'refrenceNote')} type="text" placeholder=" " name="RoleName" className="form-input" maxLength={500} />
                                    <label data-label={translations.Insurance?.['Reference Notes'] || translations.commonMsg?.loading} className="form-label"></label>
                                </div>
                            </fieldset>
                            {/* Is Fleet Account added */}
                            {
                                formType === "insurance-policy-generated" && !INS_INSURANCE_ID_STAGE 
                                ?
                                    <>
                                        <fieldset className="col-md-12">
                                            <div className='fleet-acount-block'>     
                                                <label className='fleet-label'>{translations.Insurance?.['Is Fleet Account']}:</label>
                                                <div className="radio-type-txt radio-btn gender-radio">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="radio"
                                                            className="custom-control-input "
                                                            name="is_fleet_account"
                                                            value={IS_FLEET_ACCOUNT['yes']}
                                                            checked={+isFleetAccount === IS_FLEET_ACCOUNT['yes']}
                                                            disabled={false}
                                                            onChange={(e: any) => onChangeHandler(e.target.value, 'is_fleet_account')}
                                                        />
                                                        <label className="custom-control-label">{translations.commonMsg?.['Yes'] || translations.commonMsg?.loading} </label>
                                                    </div>
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="radio"
                                                            className="custom-control-input "
                                                            name="is_fleet_account"
                                                            value={IS_FLEET_ACCOUNT['no']}
                                                            checked={+isFleetAccount === IS_FLEET_ACCOUNT['no']}
                                                            disabled={false}
                                                            onChange={(e: any) => onChangeHandler(e.target.value, 'is_fleet_account')}
                                                        />
                                                        <label className="custom-control-label">{translations.commonMsg?.['No'] || translations.commonMsg?.loading}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </>
                                :
                                null
                            }
                        </div>


                    </div>
                     {
                      (COUNTRY_CODE==='id')? 
                        <DocumentFormId 
                        docTypeId={[DOCUMENT_CATEGORY['disbursal']['doc_type_id']]} docId={[DOCUMENT_CATEGORY['disbursal']['childs']['policy_shared']]} 
                        formType={props.formType} 
                        resolveFileUpload={resolveFileUpload} 
                        submitClicked={submitClicked} 
                        errField={errField} 
                        updatedFileCount={updatedFileCount}  />: 
                        <DocumentForm docTypeId={[DOCUMENT_CATEGORY['disbursal']['doc_type_id']]} docId={(formType === 'soft-approval-received') ? [DOCUMENT_CATEGORY['disbursal']['childs']['soft_approval']] : [DOCUMENT_CATEGORY['disbursal']['childs']['policy_shared']]} formType={props.formType} resolveFileUpload={resolveFileUpload} submitClicked={submitClicked} errField={errField} updatedFileCount={updatedFileCount}  isFleetAccount={isFleetAccount}/>
                     }
                    <div className="btn-save-remarks m-xl-t">
                        {
                            HELPER.isUserHasUpdateAccess({ permissionID: (formType === 'soft-approval-received' ? ROLE_FEATURES['soft_approval_received'] : ROLE_FEATURES['insurance_policy_generated']), accessType: 'edit', leadDetails: insuranceState.leadDetail, pageSlug: formType })

                                ?
                                <button type="button" className="btn-primary" onClick={saveInsurancePolicyTemplate}
                                disabled  = { (COND_SHOW_FIELDS_ACC_INSURERS.includes(insurer_id) && sent_to_verification === SENT_TO_VERIFICATION.DONE) ? true:false }
                                >{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>
                                :
                                <button type="button" className="btn-primary" disabled>{translations.commonMsg?.['save'] || translations.commonMsg?.loading}</button>

                        }
                        <LeadRemarksButton leadId={queryParams.id} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UsePolicyForm;